import { Component, OnInit } from '@angular/core';
import { JyDashboardService, Metric } from './dashboard.service';
import { CommonsService } from '@core/service/commons.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})

export class DashboardComponent implements OnInit{

  testData: any = {};

  public timer;
  openPriceDetails = {
    open:false
  };
  salesData: any[] = [];

  constructor(public jyDashboardService:JyDashboardService,
              public metric: Metric,
              private commonsService: CommonsService,
              ){
    /*this.timer = setInterval(()=>{
      this.getMonitorData();
    },6000);*/
    this.getMonitorData();
  }

  percent:number; //初始化内存使用比
  heapPercent:number;//堆内存使用率
  requestNum:number = 0; //访问量
  threadsCountValue:number; //线程数
  threadsBlockedValue:number; //线程阻塞数
  threadsDeadlockValue:number; //死锁线程数
  serverErrorCount:number;//服务器内部错误
  serverErrordataMean_rate:number;//服务器错误率
  serverErrordataUnits:string;//单位
  timeoutsCount:number;//请求超时
  timeoutsMean_rate:number;
  timeoutsUnits:string;
  maxHeapMemoryValue:number;//初始化堆内存大小
  usedHeapMemoryValue:number;//已使用堆内存大小
  maxCodeCacheValue:number;
  usedCodeCacheValue:number;
  maxEdenSpaceValue:number;
  usedEdenSpaceValue:number;
  maxPsOldGenValue:number;
  usedPsOldGenValue:number;
  maxPsSurvivorSpaceValue:number;
  usedPsSurvivorSpaceValue:number;
  maxCompressedClassSpaceValue:number;
  usedCompressedClassSpaceValue:number;

  getMonitorData():void{
    this.jyDashboardService.getModel().subscribe((data)=>{
      this.percent = parseFloat((data.gauges[this.metric.usedMemory].value/data.gauges[this.metric.maxMemory].value*100).toFixed(1));
      this.requestNum = data.timers[this.metric.servletRequest].count

      this.threadsCountValue = data.gauges[this.metric.threadsCount].value;
      this.threadsBlockedValue = data.gauges[this.metric.threadsBlocked].value;
      this.threadsDeadlockValue = data.gauges[this.metric.threadsDeadlock].value;//死锁线程数

      this.serverErrorCount = data.meters[this.metric.serverError].count;//服务器内部错误
      this.serverErrordataMean_rate = parseFloat(data.meters[this.metric.serverError].mean_rate.toFixed(8));
      this.serverErrordataUnits = data.meters[this.metric.serverError].units;

      this.timeoutsCount = data.meters[this.metric.timeouts].count;//请求超时数
      this.timeoutsMean_rate = parseFloat(data.meters[this.metric.timeouts].mean_rate.toFixed(8));
      this.timeoutsUnits = data.meters[this.metric.timeouts].units;

      this.maxCodeCacheValue = this.metric.getMB(data.gauges[this.metric.maxCodeCache].value);
      this.usedCodeCacheValue = this.metric.getMB(data.gauges[this.metric.usedCodeCache].value);

      this.maxEdenSpaceValue = this.metric.getMB(data.gauges[this.metric.maxEdenSpace].value);
      this.usedEdenSpaceValue = this.metric.getMB(data.gauges[this.metric.usedEdenSpace].value);

      this.maxPsOldGenValue = this.metric.getMB(data.gauges[this.metric.maxPsOldGen].value);
      this.usedPsOldGenValue = this.metric.getMB(data.gauges[this.metric.usedPsOldGen].value);

      this.maxPsSurvivorSpaceValue = this.metric.getMB(data.gauges[this.metric.maxPsSurvivorSpace].value);
      this.usedPsSurvivorSpaceValue = this.metric.getMB(data.gauges[this.metric.usedPsSurvivorSpace].value);

      this.maxCompressedClassSpaceValue = this.metric.getMB(data.gauges[this.metric.maxCompressedClassSpace].value);
      this.usedCompressedClassSpaceValue = this.metric.getMB(data.gauges[this.metric.usedCompressedClassSpace].value);

      this.heapPercent = parseFloat((data.gauges[this.metric.usedHeapMemory].value/data.gauges[this.metric.maxHeapMemory].value*100).toFixed(1));
      this.generateG2bar(data);
    })
  }

  generateG2bar(data:any){
    this.salesData.push({
      x:'badRequest',
      y: data.meters[this.metric.responseCodesBadRequest].count
    });
    this.salesData.push({
      x:'created',
      y: data.meters[this.metric.responseCodesCreated].count
    });
    this.salesData.push({
      x:'noContent',
      y: data.meters[this.metric.responseCodesNoContent].count
    });
    this.salesData.push({
      x:'notFound',
      y: data.meters[this.metric.responseCodesNotFound].count
    });
    this.salesData.push({
      x:'ok',
      y: data.meters[this.metric.responseCodesOk].count
    });
    this.salesData.push({
      x:'other',
      y: data.meters[this.metric.responseCodesOther].count
    });
    this.salesData.push({
      x:'servletErrors',
      y: data.meters[this.metric.servletErrors].count
    });
  }
  ngOnInit(): void {}

  /*ngOnDestroy():void{
    if(this.timer){
      clearInterval(this.timer);
    }
  }*/
  openPrice(){
    this.openPriceDetails.open = true;
  }


  getBizObjectParameters() {
    this.commonsService.getBizObjectParameters('TEST').subscribe((data) => {
      this.commonsService.showSuccessMessage(JSON.stringify(data));
    });
  }

}

